'use client';

import React from 'react';
import Link from 'next/link';
import { track } from '@/utils/analytics';
import type { EventName, TrackProps } from '@/utils/analytics-events';

/** A link that fires one Umami event on click and then lets navigation proceed. */
export default function TrackedLink({ href, event, props, className, children }: {
  href: string;
  event: EventName;
  props?: TrackProps;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Link href={href} className={className} onClick={() => track(event, props)}>
      {children}
    </Link>
  );
}
